<template>
    <div class="teacher-box">
        <!-- 教师列表组件 -->
        <!-- 数据回显&& phoneNumber -->
        <div class="teacher-info" v-if="classTeacher">
            <div class="t_export">已选任课老师信息：</div>
            <div class="teacher-right">
                <div class="teacher-phone">
                    <div class="m">任课老师：{{ classTeacher }}</div>
                    <div>手机号码：{{ phoneNumber }}</div>
                </div>
                <div class="teacher-phone" v-if="company">
                    <div>助学单位：{{ company }}</div>
                </div>
            </div>
        </div>
        <div class="teacher_table">
            <div class='search-box'>
                <div class="teacher-list">可选任课老师列表:</div>
                <el-row style="border: none" class="search">
                    <el-col :span="7">
                        <el-input v-model="fullname" size="small" placeholder="请输入讲师姓名"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="searchTeacher" size="small">搜索</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="table-box">
                <el-table :data="teacherData" ref="teacherTable" border style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="uid" label="ID" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="fullname" label="讲师姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号码" align="center">
                    </el-table-column>
                    <el-table-column prop="profession" label="职称" align="center">
                    </el-table-column>
                    <el-table-column prop="companyName" label="助学单位" align="center">
                    </el-table-column>
                    <el-table-column prop="umajor" label="专业" align="center">
                    </el-table-column>
                </el-table>
            </div>

        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageObj.page" :page-sizes="[10, 20, 30, 40]" :page-size="pageObj.pageSize"
            layout="total, sizes, prev, pager, next, jumper" background :total="total">
        </el-pagination>
    </div>
</template>

<script>
import * as api from '@/api/ClassManagement/index'
export default {
    props: {
        classTeachers: {
            type: String,
        },
        phoneNumbers: {
            type: String,
        },
        companys: {
            type: String,
        },
    },
    computed: {
        
    },
    data() {
        return {
            teacherData: [],
            fullname: '',
            // 分页
            pageObj: {
                page: 1,
                pageSize: 20,
            },
            // 总数
            total: 0,
            // 已选任课老师信息
            classTeacher: '',
            phoneNumber: '',
            company: '',
            uids: '',
        }
    },
    created() {
        this.getTeacherUserList()
    },
    
    methods: {
        // 获取任课老师列表
        getTeacherUserList() {
            const that = this
            api.getTeacherUserList({ fullname: this.fullname, ...this.pageObj })
                .then(({ data }) => {
                    if (data.code === 100000) {
                        data.data.list.forEach((item) => {
                            item.phone = that.hideSafeInfo(item.phone)
                        })
                        this.teacherData = data.data.list
                        this.total = data.data.total
                    }
                })
        },
        // 隐藏手机号中间位数
        hideSafeInfo(content) {
            if (!content) {
                return null
            }
            const hideStart = parseInt(content.length / 3)
            const hideEnd = parseInt(content.length * 2 / 3)
            const hideLength = hideEnd - hideStart
            let hideVal = '*'
            for (let i = 1; i < hideLength; i++) {
                hideVal += '*'
            }
            const oldVal = content.substring(hideStart, hideEnd)
            return content.replace(oldVal, hideVal)
        },
        // 改变页面接收数据大小
        handleSizeChange(val) {
            this.pageObj.pageSize = val
            this.getTeacherUserList()
        },
        // 改变当前页面
        handleCurrentChange(val) {
            this.pageObj.page = val
            this.getTeacherUserList()
        },
        // 教师检索
        searchTeacher() {
            this.pageObj.page = 1;
            this.getTeacherUserList()
        },
        // 处理选中事件
        handleSelectionChange(rows) {
            if (rows.length > 1) {
                this.$refs.teacherTable.clearSelection()
                this.$refs.teacherTable.toggleRowSelection(rows.pop())
            } else if (rows.length > 0) {
                this.classTeacher = rows[0].fullname
                this.phoneNumber = this.hideSafeInfo(rows[0].phone)
                this.company = rows[0].companyName
                this.uids = rows[0].uid
            } else {
                this.classTeacher = ''
                this.phoneNumber = ''
                this.company = ''
                this.uids = ''
            }

        },


    },
    watch: {
        fullname: {
            handler: function (val) {
                this.pageObj.page = 1;
                this.getTeacherUserList()
            },
            immediate: true,
        },
        classTeachers: {
            handler: function (val) {
               this.classTeacher = val
            },
            immediate: true,
        },
        phoneNumbers: {
            handler: function (val) {
               this.phoneNumber = val
            },
            immediate: true,
        },
        companys: {
            handler: function (val) {
               this.company = val
            },
            immediate: true,
        },

        // phoneNumbers(newVal,oldVal){
        //     this.phoneNumber = newVal
        // },
        // companys(newVal,oldVal){
        //     this.company = newVal
        // },
        // this.classTeacher = this.classTeachers
        // this.phoneNumber = this.phoneNumbers
        // this.company = this.companys
    },
}
</script>

<style lang="scss" scoped>
.teacher-info {
    display: flex;
    flex-direction: row;
    align-items: center;

    .t_export {
        width: 172px !important;
        height: 40px;
        font-weight: 600;
        font-size: 18px;
    }

    .teacher-right {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        .teacher-phone {
            width: 100%;
            margin: 10px 0;
            display: flex;
            flex-direction: row;

            .m {
                margin-right: 60px;
            }
        }
    }
}

.search-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 20px;

    .search {
        margin-left: 20px;
        width: 80%;
    }

}

.table-box {
    height: 460px;
    overflow-y: auto;
}

.teacher_table {
    padding-top: 20px;
    border-top: 1px dashed #e7e7e7;

    .teacher-list {
        width: 20%;
        font-weight: 600;
        font-size: 18px;
    }
}
</style>